import { Download, Paperclip } from "lucide-react";
import { useTranslation } from "react-i18next";
import { MessageAttachment } from "../../features/messages/models/MessageAttachment";
import { formatBytes } from "../../features/messages/utils/attachmentRules";

interface AttachmentRowProps {
  attachment: MessageAttachment;
  /** The row's one action: Download for a file, Play for a video. */
  actionLabel: string;
  actionIcon?: typeof Download;
  onAction: () => void;
}

/** A file as a hairline row: its name and size, and one action at the end. */
const AttachmentRow = ({ attachment, actionLabel, actionIcon: Icon = Download, onAction }: AttachmentRowProps) => {
  const { i18n } = useTranslation();
  return (
    <div
      className="flex w-full max-w-[320px] items-center gap-3 rounded-lg border border-grey-90 px-3 py-2 dark:border-primary-20"
      data-testid="message-file"
    >
      <Paperclip size={16} className="shrink-0 text-grey-40 dark:text-grey-80" aria-hidden="true" />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm text-grey-20 dark:text-white">{attachment.fileName}</p>
        <p className="text-xs text-grey-40 dark:text-grey-80">{formatBytes(attachment.sizeBytes, i18n.language)}</p>
      </div>
      <button
        type="button"
        className="btn btn-text shrink-0"
        onClick={onAction}
        aria-label={`${actionLabel}: ${attachment.fileName}`}
      >
        <Icon size={16} aria-hidden="true" />
        <span className="hidden sm:inline">{actionLabel}</span>
      </button>
    </div>
  );
};

export default AttachmentRow;
